import { gql } from "apollo-boost"

export const UPDATE_MINISTRATION_PERIODS = gql`
  mutation UpdateMinistrationPeriods($ministrationPeriodsData: [UpdateMinistrationPeriodInput!]!) {
    UpdateMinistrationPeriods(
      ministrationPeriodsData: $ministrationPeriodsData
    ) {
      id
      createdAt
      deletedAt
      modifiedAt
      orderIndex
      revisionDueDate
      revisionStartDate
      revisionEndDate
      ministrationDueDate
      ministrationStartDate
      ministrationEndDate
    }
  }
`